import { ErrorBoundary } from "@datadog/browser-rum-react";
import { initDatadogRum } from "./lib/datadog-rum";
import { createRoot } from "react-dom/client";

initDatadogRum();
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import { AppErrorFallback } from "./components/AppErrorFallback";
import { RouterErrorFallback } from "./components/RouterErrorFallback";
import "./index.css";
import { Auth0Provider } from "./providers/Auth0Provider";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure there is a <div id='root'></div> in your index.html file."
  );
}

const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
    errorElement: <RouterErrorFallback />,
  },
]);

createRoot(rootElement).render(
  <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false}>
    <ErrorBoundary fallback={AppErrorFallback}>
      <Auth0Provider>
        <RouterProvider router={router} />
      </Auth0Provider>
    </ErrorBoundary>
  </ThemeProvider>
);
  